import { BuildClass, fsmData } from '../../../../universal';
import { React, _ } from '../../../lib';
import { Checkbox } from '../checkbox';
import { Combobox } from '../combobox';
import { LoadingSpinnerLarge } from '../loading';
import { definedComponentsGeneric } from '../report-frame';
import { Textbox } from '../textbox';
import { Action, sendOnUpdate } from './actions';
import { getReportByKey } from './ui-manager';
const LABEL_CLASS = 'pt-[5px] pb-[10px] px-[10px]';
const SPAN_CLASS = 'block font-condensed font-light px-1 text-[#555]';
export const ReportJobManagerOptions = (props) => {
    if (!props.rpt) {
        return React.createElement(StubMessage, { msg: "Select a report" });
    }
    const rj = props.rs.state.reportJobs[props.rj ?? -1];
    const rpt = rj?.Reports[props.rpt ?? 0];
    if (!rpt) {
        return React.createElement(StubMessage, { msg: "Invalid report" });
    }
    if (!props.rs.state.cache) {
        return React.createElement(LoadingSpinnerLarge, null);
    }
    const params = props.rs.state.cache.params?.[rpt.Type ?? ''];
    const exports = props.rs.state.cache.exports?.[rpt.Type ?? ''] ?? [];
    const updateState = (deltaFn) => {
        props.rs.dispatch([
            Action.UpdateReport,
            {
                rj: rj.ID,
                rpt: rpt.ID,
                update: deltaFn,
            },
        ]);
        sendOnUpdate(props.rs);
    };
    const buildRadioButton = (exportType, lbl) => (React.createElement(Checkbox, { className: "mx-2", radioGroup: "export-type", disabled: !exports.includes(exportType), cbStyle: "radio", lbl: lbl, value: rpt.ExportType == exportType, onUpdate: v => {
            if (v) {
                updateState(() => ({ ExportType: exportType }));
            }
        } }));
    return (React.createElement("div", { className: "h-full overflow-y-scroll" },
        React.createElement("label", { className: BuildClass({
                block: true,
                [LABEL_CLASS]: true,
            }) },
            React.createElement("span", { className: SPAN_CLASS }, "Report Type"),
            React.createElement(Combobox, { className: "w-full min-w-full", value: rpt.Type, onUpdate: v => {
                    const default_title = getReportByKey(props.rs, v)?.Title ?? '';
                    const export_types = props.rs.state.cache?.exports?.[v ?? ''] ?? [];
                    updateState(s => ({
                        Type: v,
                        Name: s.Name || default_title,
                        ExportType: _.first(export_types),
                        Params: _.fromPairs(_.map(props.rs.state.cache?.params?.[v ?? ''], x => [
                            x.Key,
                            x.Default ??
                                getComponentType(props.rs, x.Type).defVal?.() ??
                                null,
                        ])),
                    }));
                }, options: _.compact(_.map(props.rs.props.reportGroups, grp => {
                    const first = grp.Items[0];
                    if (grp.Items.length > 1) {
                        return {
                            text: grp.Name,
                            options: fsmData(grp.Items, {
                                filter: R => !R.Unavailable,
                                sort: R => R.ID,
                                map: R => ({
                                    value: R.Key,
                                    text: R.Title,
                                }),
                            }),
                        };
                    }
                    else if (first) {
                        return {
                            value: first.Key,
                            text: first.Title,
                        };
                    }
                    return null;
                })) })),
        React.createElement("label", { className: BuildClass({
                block: true,
                [LABEL_CLASS]: true,
            }) },
            React.createElement("span", { className: SPAN_CLASS }, "Report Name"),
            React.createElement(Textbox, { className: "w-full min-w-full", value: rpt.Name, onUpdate: v => {
                    updateState(() => ({ Name: v }));
                }, maxLength: 60 })),
        React.createElement("div", { className: "w-full text-center" },
            buildRadioButton(1, 'PDF'),
            buildRadioButton(2, 'XLSX'),
            buildRadioButton(3, 'CSV')),
        React.createElement(React.Fragment, null, _.map(params, v => (React.createElement(ReportJobManagerOption, { key: v.Key, rs: props.rs, rj: props.rj, rpt: props.rpt, optionType: v.Type, options: v.Options, lbl: v.Label, value: rpt.Params[v.Key], onUpdate: newVal => {
                updateState(s => ({
                    Params: {
                        ...s.Params,
                        [v.Key]: newVal,
                    },
                }));
            } }))))));
};
export const StubMessage = (props) => (React.createElement("div", { className: "text-center text-neutral-600 pt-10 text-xl font-light" }, props.msg));
const ReportJobManagerOption = (props) => {
    const rs = props.rs;
    const componentOriginal = getComponentType(rs, props.optionType);
    const component = React.cloneElement(componentOriginal.cmpt({ label: props.lbl, options: props.options }), {
        key: 'cmpt',
        className: BuildClass({
            [componentOriginal.className ?? '']: true,
            'max-w-full min-w-full': true,
        }),
        value: props.value,
        onUpdate: (v) => {
            const val = (componentOriginal.validate ?? _.identity)(v);
            props.onUpdate(val);
        },
    });
    const lblDisplay = props.optionType != 'TypeBool' ? props.lbl : '';
    return (React.createElement("label", { className: BuildClass({
            block: true,
            [componentOriginal.paddingClass ?? LABEL_CLASS]: true,
            [componentOriginal.className ?? '']: true,
        }) },
        React.createElement("div", { className: "flex" },
            React.createElement("span", { className: BuildClass({
                    [SPAN_CLASS]: true,
                }) }, lblDisplay),
            React.createElement("span", null)),
        component));
};
const getComponentType = (rs, type) => {
    const cmpt = definedComponentsGeneric[type] ?? rs.props.getReportComponent(type);
    if (!cmpt) {
        return {
            defVal: () => null,
            cmpt: () => React.createElement("div", null,
                "Error loading option of type \"",
                type,
                "\""),
        };
    }
    return cmpt;
};
//# sourceMappingURL=ui-options.js.map